import { gsap } from 'gsap';

export function useGsapStaggerFrom(elementRef) {
	const play = (options) => {
		if (!elementRef.value?.children?.length) {
			console.warn('GSAP animation target not found or has no children.');
			return;
		}
		gsap.from(elementRef.value.children, {
			opacity: 0,
			y: 30,
			duration: 1.5,
			ease: 'power3.out',
			stagger: 0.2,
			...options,
		});
	};

	return { play };
}
